import React from 'react'
import HomeContent from '../components/HomeContent'

function Home() {
  return (
    // <div className='flex justify-center items-center h-screen text-white text-3xl '>
    //     Home
    // </div>

      <HomeContent/>
 
    
  )
}

export default Home